import { render, staticRenderFns } from "./NpsButtonsColored.vue?vue&type=template&id=118293bd&"
import script from "./NpsButtonsColored.vue?vue&type=script&lang=ts&"
export * from "./NpsButtonsColored.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports